'use strict';

const filter = require('lodash/filter');
const forEach = require('lodash/forEach');

function controller($scope, $attrs, $element, inventoryService) {
    let scriptTag = $element[0];
    let prodNo = parseInt($attrs.prodNo, 10);

    inventoryService.getPerformances().then(data => {
        let performances = filter(data, performance => {
           return performance.prod_season_no === prodNo;
        });

        let schemaData = [];

        forEach(performances, performance => {
            let ldData = {
                '@context': 'http://schema.org',
                '@type': 'TheaterEvent',
                'identifier': performance.perf_no,
                'name': performance.title,
                'startDate': performance.start_date_moment.format('YYYY-MM-DDTHH:mm:ssZ'),
                'endDate': performance.end_date_moment.format('YYYY-MM-DDTHH:mm:ssZ'),
                'image': performance.image_url,
                'url': performance.event_url,
                'description': performance.summary,
                'location': setLocation(performance),
                'performer': {
                    '@type': 'Thing',
                    'name': 'Organization'
                },
                'offers': ''
            };

            schemaData.push(ldData);
        });

        scriptTag.setAttribute('type', 'application/ld+json');
        scriptTag.innerHTML = JSON.stringify(schemaData);
    });

    function setLocation(performance) {
        return {
            '@type': 'Place',
            'name': performance.facility_title,
            'address': {
                '@type': 'PostalAddress',
                'streetAddress': performance.facility_street_address,
                'addressLocality': performance.facility_address_locality,
                'postalCode': performance.facility_postal_code,
                'addressCountry': performance.facility_address_country
            }
        };
    }
}

module.exports = [
    '$scope',
    '$attrs',
    '$element',
    'inventoryService',
    controller
];
